import { render, staticRenderFns } from "./JoistForm.vue?vue&type=template&id=015e3670"
import script from "./JoistForm.vue?vue&type=script&lang=js"
export * from "./JoistForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports